<template>
  <div class="upload">
    <van-uploader
      :before-read="beforeRead"
      accept="*"
      v-model="fileList"
      :after-read="afterRead"
      :preview-image="false"
      :max-count="1"
      :show-upload="true"
      upload-icon="https://static.xchengtech.cn/e6bade65dab149af84f919aa32ad125d.png"
      :before-delete="handleDelete"
    >
      <div class="uploadBtn">
        <img
          src="https://static.xchengtech.cn/ca0dc111e906443193c574d6b25ef2f1.png"
          alt=""
        />
        <span>文件解析</span>
      </div>
    </van-uploader>
    <!-- 文件信息显示区域已移至父组件 -->
    <!-- 必须存在：plupload 依赖的 DOM 容器（隐藏，仅用于实例初始化） -->
    <div id="plupload-dom-container" style="display: none">
      <div id="container">
        <button id="selectfiles"></button>
        <button id="postfiles"></button>
      </div>
      <div id="ossfile"></div>
      <pre id="console"></pre>
    </div>
    <van-dialog v-model="show" :show-confirm-button="false">
      <div class="typeError">
        <div class="title">
          <div>文件格式错误</div>
          <div>仅支持以下格式的文件</div>
        </div>
        <div class="txt">
          <div>
            <span>文本文件</span>
            <span>TXT、DOCX、PDF、XLSX、EPUB、MD、MOBI、CSV、JSON</span>
          </div>
          <div>
            <span>图片文件</span><span>BMP、PNG、JPG/JPEG、GIF、PDF扫描件</span>
          </div>
        </div>
        <div class="btn">
          <span @click="show = !show">确认</span>
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="tipsShow" :show-confirm-button="false">
      <div class="tipsShow">
        <div class="title">上传附件说明</div>
        <div class="txt">
          可以上传产品手册、产品文档，或是对于产品信息描述的文件
        </div>
        <div class="fileType">
          <div>
            <span>支持的文件格式：</span>
            <span>TXT、DOCX、PDF、XLSX、EPUB、MD、MOBI、CSV、JSON</span>
          </div>
          <div>
            <span>支持的图片格式：</span
            ><span>BMP、PNG、JPG/JPEG、GIF、PDF扫描件</span>
          </div>
        </div>
        <div class="btn">
          <span @click="tipsShow = !tipsShow">我知道了</span>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import { pyxApply, getPolicyObj } from "@/api/robot";
import plupload from "plupload";
import { Field, Uploader, Toast, Dialog } from "vant";
import { simpleUuid } from "@/utils/index";
Vue.use(Toast);
Vue.use(Field);
Vue.use(Uploader);
export default {
  data() {
    return {
      show: false,
      accessid: "",
      accesskey: "",
      host: "",
      policyBase64: "",
      signature: "",
      callbackbody: "",
      key: "", //直接放在bucket根目录
      expire: 0,
      g_object_name: "",
      g_object_name_type: "",
      now: Date.parse(new Date()) / 1000,
      timestamp: Date.parse(new Date()) / 1000,
      uploader: "",
      body: "",
      new_multipart_params: "",
      suffix: "",
      policyObj: {},
      // 保存本地表的文件名称
      fileName: "",
      // 上传至oss的文件名称
      fileNameForUUid: "",
      // 父组件需要上传的文件类型
      type: "",
      fileList: [],
      // 选中的文件信息
      selectedFile: null,
      fileRules: {
        maxSize: 150 * 1024 * 1024, // 150MB（字节）
        // 文本文件：TXT、DOCX、PDF、XLSX、EPUB、MOBI、MD、CSV、JSON
        text: {
          mimeTypes: [
            "text/plain", // TXT
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
            "application/pdf", // PDF
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
            "application/epub+zip", // EPUB
            "application/x-mobipocket-ebook", // MOBI
            "text/markdown", // MD
            "text/csv", // CSV
            "application/json", // JSON
          ],
          suffixes: [
            ".txt",
            ".docx",
            ".pdf",
            ".xlsx",
            ".epub",
            ".mobi",
            ".md",
            ".csv",
            ".json",
          ],
        },
        // 图片文件：BMP、PNG、JPG/JPEG、GIF、PDF扫描件（PDF已包含在文本类，此处无需重复）
        image: {
          mimeTypes: [
            "image/bmp", // BMP
            "image/png", // PNG
            "image/jpeg", // JPG/JPEG
            "image/gif", // GIF
          ],
          suffixes: [".bmp", ".png", ".jpg", ".jpeg", ".gif"],
        },
      },
      
      tipsShow: false,
    };
  },

  mounted() {
    // 页面加载时初始化plupload实例（确保DOM渲染完成后执行）
    this.initPlupload();
  },
  created() {
    this.toGetPolicyObj();
  },

  methods: {
    // 校验文件方法
    beforeRead(file) {
      const { maxSize, text, image } = this.fileRules;
      const fileName = file.name.toLowerCase(); // 文件名转小写，避免大小写问题
      const fileSize = file.size; // 文件大小（字节）
      // 1. 校验文件大小
      if (fileSize > maxSize) {
        Toast(
          `文件过大！单个文件最大支持150MB，当前文件${(
            fileSize /
            1024 /
            1024
          ).toFixed(2)}MB`
        );
        return false;
      }

      // 2. 校验文件格式（文本/图片二选一，后缀或MIME匹配即可）
      const isTextFile =
        text.mimeTypes.includes(file.type) ||
        text.suffixes.some((suffix) => fileName.endsWith(suffix));

      const isImageFile =
        image.mimeTypes.includes(file.type) ||
        image.suffixes.some((suffix) => fileName.endsWith(suffix));

      if (!isTextFile && !isImageFile) {
        // 文件格式不合法
        // 打开文件格式弹窗
        this.show = !this.show;
        return false;
      }

      // 3. 格式和大小都合法，允许上传
      return true;
    },
    // 上传前置方法
    afterRead(file) {
      // 设置选中的文件信息
      this.selectedFile = {
        name: file.file.name,
        size: file.file.size,
        type: file.file.type,
        lastModified: file.file.lastModified,
        rawFile: file.file,
      };
      
      // 上传文件列表添加文件
      this.uploader.addFile(file.file);

      // 启用上传
      this.set_upload_param(this.uploader, "", true);
      
      // 清空fileList，确保上传按钮一直显示
      this.fileList = [];
    },
    toGetPolicyObj() {
      getPolicyObj().then((res) => {
        this.policyObj = res;
      });
    },


    // 上传文件方法
    get_signature() {
      let obj = this.policyObj;
      this.host = obj["host"];
      this.policyBase64 = obj["policy"];
      this.accessid = obj["accessId"];
      this.signature = obj["signature"];
      this.expire = parseInt(obj["expire"]);
      this.callbackbody = obj["callback"];
      this.key = obj["dir"];
    },
    get_suffix(filename) {
      let pos = filename.lastIndexOf(".");
      let suffix = "";
      if (pos != -1) {
        suffix = filename.substring(pos);
      }
      return suffix;
    },
    get_uploaded_object_name(filename) {
      if (this.g_object_name_type == "local_name") {
        tmp_name = this.g_object_name;
        tmp_name = tmp_name.replace("${filename}", filename);
        return tmp_name;
      } else if (this.g_object_name_type == "random_name") {
        return this.g_object_name;
      }
    },
    // 设置上传参数并启动上传
    set_upload_param(up, filename, ret) {
      this.get_signature();
      this.g_object_name = this.key;
      if (filename != "") {
        this.suffix = this.get_suffix(filename);
      }
      this.new_multipart_params = {
        key: this.key + filename,
        policy: this.policyBase64,
        OSSAccessKeyId: this.accessid,
        success_action_status: "200", //让服务端返回200,不然，默认会返回204
        callback: this.callbackbody,
        signature: this.signature,
      };

      up.setOption({
        // 'url': host,
        multipart_params: this.new_multipart_params,
      });
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0, // 持续展示 toast
      });
      up.start();
    },
    initPlupload() {
      let that = this;
      this.uploader = new plupload.Uploader({
        runtimes: "html5,flash,silverlight,html4",
        browse_button: "selectfiles",
        container: document.getElementById("container"),
        url: "https://static.xchengtech.cn",
        filters: {
          max_file_size: "150mb", //最大只能上传10mb的文件
        },

        init: {
          BeforeUpload: function (up, file) {
            let uuid = simpleUuid();
            // 解析文件名
            let parts = file.name.split(".");
            that.fileNameForUUid =
              uuid + "." + parts[parts.length - 1].toLowerCase();
            that.fileName = file.name;
            that.set_upload_param(up, that.fileNameForUUid, true);
          },

          FileUploaded: function (up, file, info) {
            if (info.status == 200) {
              let url = "https://static.xchengtech.cn/" + that.fileNameForUUid;
              Toast.clear();
              console.log("url",url);
              
              // 上传完成后，将文件信息传递给父组件
              if (that.selectedFile) {
                that.$emit('file-uploaded', {
                  ...that.selectedFile,
                  url: url
                });
              }
            } else if (info.status == 203) {
              console.log(
                "上传到OSS成功，但是oss访问用户设置的上传回调服务器失败，失败原因是:" +
                  info.response
              );
            } else {
              console.log("错误:" + info.response);
              Toast.clear();
            }
          },

          Error: function (up, err) {
            console.log("err", err);
            Toast.clear();
            if (err.code == -600) {
              console.log(
                "选择的文件太大了,可以根据应用情况，在upload.js 设置一下上传的最大大小"
              );
            } else if (err.code == -601) {
              console.log(
                "选择的文件后缀不对,可以根据应用情况，在upload.js进行设置可允许的上传文件类型"
              );
            } else if (err.code == -602) {
              console.log("这个文件已经上传过一遍了");
            } else {
              console.log("nError xml:" + err.response);
            }
          },
        },
      });
      this.uploader.init();
    },
    handleDelete() {
      // 1. 清空plupload上传队列（避免残留文件）
      this.fileList = [];

      // 2. 清空组件内存储的文件名（OSS关联信息）
      this.fileName = "";
      this.fileNameForUUid = "";

      // 3. 清空父组件表单中的文件地址
      this.$set(this.$parent.form, "file", "");
    },
  },
};
</script>
<style scoped>
#ossfile /deep/ .progress {
  margin-top: 2px;
  width: 100%;
  height: 14px;
  margin-bottom: 10px;
  overflow: hidden;
  background-color: #f5f5f5;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
}
#ossfile /deep/ .progress-bar {
  background-color: rgb(92, 184, 92);
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.14902) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.14902) 50%,
    rgba(255, 255, 255, 0.14902) 75%,
    transparent 75%,
    transparent
  );
  background-size: 40px 40px;
  box-shadow: rgba(0, 0, 0, 0.14902) 0px -1px 0px 0px inset;
  box-sizing: border-box;
  color: rgb(255, 255, 255);
  display: block;
  float: left;
  font-size: 12px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  transition-delay: 0s;
  transition-duration: 0.6s;
  transition-property: width;
  transition-timing-function: ease;
  width: 266.188px;
}
#ossfile /deep/ .item {
  margin-top: 20px;
}
#ossfile /deep/ .item:nth-of-type(1) {
  display: flex;
  justify-content: space-between;
}
.tip {
  margin-bottom: 10px;
}
.upload {
  padding: 4vw;
  display: flex;
  align-items: center;
}
.upload /deep/ .van-uploader .van-uploader__preview,
.upload /deep/ .van-uploader .van-uploader__upload {
  margin: 0;
}
.upload /deep/ .van-uploader .van-uploader__upload {
  /* background-color: #eef0f286; */
  border-radius: 12px;
}
.upload /deep/ .van-uploader .van-uploader__upload .van-uploader__upload-icon {
  font-size: 30px;
}
.upload .upload-title {
  font-weight: 600;
  color: #2a4067;
  width: 5.2em;
  font-size: 4vw;
  margin-right: 12px;
}
.typeError {
  padding: 4vw;
  background-image: linear-gradient(to bottom, #dce7f8 0%, white 50%);
}
.typeError .title {
}
.typeError .title div:nth-of-type(1) {
  color: #1b293f;
  font-size: 5vw;
  font-weight: 600;
  padding-bottom: 1vw;
}
.typeError .title div:nth-of-type(2) {
  color: #8290a6;
  font-size: 3.6vw;
}
.typeError .txt {
  padding-top: 4vw;
  display: grid;
  gap: 3vw;
}
.typeError .txt span {
  display: block;
}
.typeError .txt div span:nth-of-type(1) {
  color: #1b293f;
  font-size: 4vw;
}
.typeError .txt div span:nth-of-type(2) {
  color: #7f8fa8;
  font-size: 3.6vw;
}
.typeError .btn {
  padding-top: 6vw;
}
.typeError .btn span {
  display: block;
  background-color: #418bf8;
  border-radius: 35px;
  text-align: center;
  color: white;
  padding: 3vw 0;
  font-size: 4.2vw;
}
/* 可上传文件类型弹窗 */
.tipsShow {
  padding: 4vw;
  background-image: linear-gradient(to bottom, #dce7f8 0%, white 50%);
}
.tipsShow .title {
  color: #1b293f;
  font-size: 5vw;
  font-weight: 600;
}
.tipsShow .txt {
  padding-top: 4vw;
  color: #1b293f;
  font-size: 4vw;
  line-height: 7vw;
}
.tipsShow .btn {
  padding-top: 4vw;
}
.tipsShow .btn span {
  display: block;
  background-image: linear-gradient(45deg, #188ffe 0%, #387eed 80%);
  border-radius: 35px;
  text-align: center;
  color: white;
  padding: 3vw 0;
  font-weight: 600;
  font-size: 4.2vw;
}
/* 文件类型说明 */
.fileType {
  padding-top: 4vw;
  color: #1b293f;
  font-size: 4vw;
  line-height: 7vw;
}
.fileType div {
  padding-bottom: 4vw;
}
.fileType div span {
  display: block;
}
.fileType div span:nth-of-type(1) {
  color: #1b293f;
  font-size: 4vw;
}
.fileType div span:nth-of-type(2) {
  color: #7f8fa8;
  font-size: 3.6vw;
}

/* 文件信息显示样式已移至父组件 */
/* 上传文件按钮样式 */
.uploadBtn {
  display: flex;
  gap: 1vw;
  align-items: center;
  background-color: white;
  padding: 2vw 3vw;
  border-radius: 8px;
  border: 1px solid #dfdfdf;
  align-items: center;
  font-size: 3.6vw;
}
.uploadBtn img {
  display: block;
  width: 4vw;
}
.uploadBtn .upload {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/robot/fileUploader/index.vue